import React, { FC } from 'react';

import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import styled from 'styled-components';

import IconCheck from 'components/icons/check';

interface IGameplayCheckboxProps {
  name: string;
  label?: string;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
}

/**
 * Hidden input for native checkbox
 */
const HiddenInput = VisuallyHidden.withComponent('input');

/**
 * Chexkbox label
 */
const Label = styled.label`
  display: flex;
  justify-content: start;
  vertical-align: middle;
  user-select: none;
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 0.9rem;
`;

/**
 * Wrapper for native and custom checkbox.
 */
const CheckContainer = styled.div`
  display: inline-block;
  margin-right: 0.5rem;
`;

/**
 * Custom styled check box
 */
const CheckBox = styled.div<{ checked?: boolean }>`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: ${Styles.borderRadius};
  border: 1px solid ${Styles.color.white};
  vertical-align: middle;

  ${HiddenInput}:focus + & {
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
  }
`;

/**
 * Custom styled check for checkbox
 */
const Check = styled(IconCheck)`
  fill: ${Styles.color.white};
  height: 7px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 10px;
  z-index: ${Styles.zIndex.below};
`;

/**
 * A checkbox styled specifically for RUtR gameplay.
 */
export const GameplayCheckbox: FC<IGameplayCheckboxProps> = ({
  checked,
  label,
  className,
  required,
  ...props
}) => {
  return (
    <Label className={className}>
      <CheckContainer>
        <HiddenInput type="checkbox" checked={checked} required={required} {...props} />
        <CheckBox checked={checked}>{checked && <Check />}</CheckBox>
      </CheckContainer>
      {label}
    </Label>
  );
};
